import { useMemo } from "react";
import { Control, useWatch } from "react-hook-form";

import { DataTemplateResponse } from "@/redux/datablocks/types";
import {
  buildFieldValuesDict,
  getHiddenFieldIds,
} from "@/domains/datablocks/fields/validators";
import { DataBlockFormFields } from "@/domains/datablocks/types";

/**
 * Hook to determine which fields should be hidden based on dependent validation rules
 * Returns a Set of field IDs that should be hidden
 */
export const useFieldVisibility = (
  dataTemplate: DataTemplateResponse,
  control: Control<DataBlockFormFields>,
): Set<number> => {
  const { validationRules } = dataTemplate;

  const fieldValuesArray = useWatch({
    control,
    name: "fieldValues",
  });

  return useMemo(() => {
    if (!fieldValuesArray) {
      return new Set<number>();
    }

    return getHiddenFieldIds(
      validationRules,
      buildFieldValuesDict(fieldValuesArray),
    );
  }, [fieldValuesArray, validationRules]);
};
